import type { SVGProps } from 'react';

const Construction = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.25 5.75H4.75V10.25M19.25 5.75V10.25H16.25M19.25 5.75L16.75 10.25M4.75 10.25H7.75M4.75 10.25L7.25 5.75M7.75 10.25V18.25M7.75 10.25H16.25M7.75 10.25L10.25 5.75M16.25 10.25V18.25M13.25 5.75L10.75 10.25M16.25 5.75L13.75 10.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Construction;
